﻿import '../../css/pages/listing.scss';
import 'bootstrap';
import { setUpWishlistBtnEventListeners } from '../modules/wishlist/wishlist-ui';
import SetupReadmore from '../modules/readmore/readmore';
import componentCarousel from '../modules/component-carousel/component-carousel';
import { isMobile, isTablet } from '../modules/mobile-detect/mobile-detect';
import { setupFilters, filterOffsetFromTopOfPage, addFilterDrawEventHandlers, toggleBodyOverflow } from '../modules/filters/filters';
import {
    pageLoader,
    appendPageContent,
    pagingForPrevNext,
    setupCaptureClicks,
    PageLoaderOptions } from '../modules/page-loader/page-loader';
import { saveScrollPosition, clearSavedScrollPosition, getSavedOpenFilter, clearOpenFilter } from '../modules/page-loader/utility-functions';
import { addOffCanvasPanelListeners } from '../modules/off-canvas-panel/off-canvas-panel';
import getClosest from '../modules/get-closest/get-closest';
import { scrollTo } from '../modules/utility-functions/utility-functions';
import priceSlider from '../modules/range-slider/range-slider';
import tippy from 'tippy.js';
import productCompare from '../modules/product-compare/product-compare';
import lazyHTML from '../modules/lazy-html/lazy-html';
import { addToBag } from '../modules/bag/bag-services';
import { previewQuickbasket, updateQuickBasketCount, updateBasketTotal } from "../modules/quick-basket/quick-basket-ui";
import { isAny } from "../modules/mobile-detect/mobile-detect";
import { gaTracking } from '../modules/event/event';
import { associatedSwatchRollovers } from '../modules/associated-product/associated-product';
import { addInsuranceCheck } from '../modules/buy-grid/buy-grid';
import { initMobileProductGrid, mobileProductGridLayout } from '../modules/mobile-product-grid-toggle/mobile-product-grid-toggle';

let viewedItems = [];
export function init() {
    console.log("You are on the listing page");
    setupListingPage();
    SetupReadmore();   
    lazyHTML();
    quickAddToBag();
    viewListTracking();
    associatedSwatchRollovers();
    initMobileProductGrid();

    pageLoader({
        updateMethod: appendPageContent,
        pagingHandler: pagingForPrevNext,
        beforeUpdate: getReadyForNewPageContent,
        afterUpdate: afterUpdate,
        setupScrollClickHandler: handleProductClick,
        activationMethod: {
            next: 'scroll',
            previous: "scroll"
        },
        paging: {
            container: '.paging-container',
            next: '.js-page-next',
            prev: '.js-page-prev',
            insertNextAfter: '.js-paging-info'
        },
        autoPaging: true
    });

    priceSlider();
    setupEventListeners();
    filterSelectedCheck();
    addFilterDrawEventHandlers();
    updatePLPCount();
    clearOpenFilter();
    productCompare();
    addInsuranceCheck();

    const pagingProgress = document.querySelector('.paging-progress') as HTMLElement;

    if (pagingProgress && typeof pagingProgress.dataset.percentage !== 'undefined') {
        updateProgressBar(parseInt(pagingProgress.dataset.total), parseInt(pagingProgress.dataset.page));
    }

    setTimeout(() => { clearSavedScrollPosition(); }, 2000)

    if (!isMobile()) {
        import('../modules/scroll-to-top/scroll-to-top')
            .then(scrollToTop => {
                scrollToTop.scrollToTop();
            });
    }
    const makeSelect = document.getElementById('tailgateMake') as HTMLSelectElement;
    makeSelect?.addEventListener('change', e => {
        const elem = e.target as HTMLInputElement;
        window.location.href = elem.value;
    });

    // Subcat expand
    const subcatViewAll = document.querySelector('.js-subcat-show-all') as HTMLElement;
    const subcatHidden = document.querySelectorAll('.category-link.d-none') as NodeListOf<HTMLElement>;
    if (subcatViewAll) {
        subcatViewAll.addEventListener('click', () => {
            subcatHidden.forEach(sub => sub.classList.remove('d-none'));
            subcatViewAll.classList.add('d-none');
            document.querySelectorAll('.category-links').forEach(container => container.classList.remove('justify-content-xl-center'));
        });
    }

    const categoryLinks = document.querySelector('.category-links') as HTMLElement;
    if (categoryLinks) categoryLinkScroll(categoryLinks);

    prevPageCheck();
}

const filterWatchElements = [
    '.filters-draw',
    '.paging-container',
    '.js-pagination'
    //'.category-attributes',
    //'.category-links'
];

const handleProductClick = () => {
    const item = '.associated-product';
    const contextElement = document.querySelector('.js-listing-page');

    contextElement?.addEventListener('click', function (event) {
        const target = event.target as HTMLElement;
        const element = target.classList.contains(item)
            ? target
            : getClosest(target, item);

        if (!element) return;


        saveScrollPosition((element as HTMLElement).getAttribute('data-pid'));
        productClickTracking(element);

        const currentUrl = new URL(window.location.href);

        // Check if this is a search page
        if (currentUrl.pathname.includes('search') && currentUrl.searchParams.has('q')) {
            event.preventDefault();

            const searchTerm = currentUrl.searchParams.get('q');
            const anchor = target.closest('a') as HTMLAnchorElement;

            if (!anchor || !searchTerm) return;

            // Build new URL for the clicked product
            const productUrl = new URL(anchor.href, window.location.origin);
            productUrl.searchParams.set('search_term', searchTerm);

            window.location.href = productUrl.toString();
        }
    });
};


const getReadyForNewPageContent = (newHTML, options) => {

    return new Promise((resolve) => {

        try {
            const existing = document.querySelector('.js-listing-page');
            const openFilters = existing.querySelectorAll('.is-selected');

            openFilters.forEach(openFilter => {
                let filterName = openFilter.getAttribute('data-name');
                let newFilter = newHTML.querySelector(`[data-name="${filterName}"]`);

               
                if (newFilter) {
                    newFilter.classList.add('active');
                }
            });

            setupCaptureClicks(newHTML, filterWatchElements);
            setupListingPage(newHTML);
            resolve(newHTML);
        }
        catch (err) {
            console.log(err);
        }
    });
};

const afterUpdate = (newHTML) => {
    toggleBodyOverflow(true);
    addFilterDrawEventHandlers();
    replaceCopy(newHTML);
    replaceFilters(newHTML);
    scrollFilters();
    addOffCanvasPanelListeners();
    tippy('[data-tippy-content]', {
        arrow: true
    });  

    priceSlider();
    replacePaginationInfo(newHTML);
    updatePLPCount();
    lazyHTML();
    mobileProductGridLayout();
    initMobileProductGrid();
    const pagingProgress = document.querySelector('.paging-progress') as HTMLElement;

    if (pagingProgress && typeof pagingProgress.dataset.percentage !== 'undefined') {
        updateProgressBar(parseInt(pagingProgress.dataset.total), parseInt(pagingProgress.dataset.page));
    }

    updatePriceSliderPrices();

    const categoryLinks = document.querySelector('.category-links') as HTMLElement;
    if (categoryLinks) categoryLinkScroll(categoryLinks);

    setTimeout(() => {
        productCompare();
        SetupReadmore();
        quickAddToBag();
    }, 2000);
};

const updatePriceSliderPrices = () => {    
    setTimeout(() => {
        const inputMin = document.querySelector('.input-min') as HTMLInputElement;
        const inputMax = document.querySelector('.input-max') as HTMLInputElement;
        const jsonURL = JSON.parse('{"' + decodeURI(location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');

        try {
            const newMin = jsonURL.price.split(';')[0];
            const newMax = jsonURL.price.split(';')[1];
        
            inputMin.value = newMin;
            inputMin.dispatchEvent(new Event('input'));

            inputMax.value = newMax;
            inputMax.dispatchEvent(new Event('input'));
        } catch (e) {
            console.log("Price filter not selected");
        }
    }, 500);
};

function replaceCopy(newHTML) {
    const categoryHeader = newHTML.querySelector('.category-header') as HTMLElement;
    if (categoryHeader)  (document.querySelector('.category-header') as HTMLElement).innerHTML = categoryHeader.innerHTML;

    const breadcrumb = newHTML.querySelector('.breadcrumb') as HTMLElement;
    if (breadcrumb) (document.querySelector('.breadcrumb') as HTMLElement).innerHTML = breadcrumb.innerHTML;    

    const listingPageFooter = newHTML.querySelector('.js-listing-page-footer') as HTMLElement;
    if (listingPageFooter) (document.querySelector('.js-listing-page-footer') as HTMLElement).innerHTML = listingPageFooter.innerHTML;

    const productCount = newHTML.getElementById('productCount') as HTMLSpanElement;
    if (productCount) (document.getElementById('productCount') as HTMLSpanElement).innerHTML = productCount.innerHTML;
}

function replacePaginationInfo(newHTML) {
    const pagingInfo = newHTML.querySelector('.paging-info') as HTMLElement;
    const oldPagingInfo = document.querySelector('.paging-info') as HTMLElement;

    oldPagingInfo.parentNode.insertBefore(pagingInfo, oldPagingInfo);
    oldPagingInfo.parentNode.removeChild(oldPagingInfo);
}

function replaceFilters(newHTML) {
    const filterHorizontal = newHTML.querySelector('.filters-container') as HTMLElement;
    const oldFilterHorizontal = document.querySelector('.filters-container') as HTMLElement;

    oldFilterHorizontal.parentNode.insertBefore(filterHorizontal, oldFilterHorizontal);
    oldFilterHorizontal.parentNode.removeChild(oldFilterHorizontal);

    if (getSavedOpenFilter()) {
        newHTML.querySelector(`.filters-draw .filter-group[data-name="${getSavedOpenFilter()}"]`).classList.add('active');
        newHTML.querySelector(`.filters-draw .filter-group[data-name="${getSavedOpenFilter()}"]`).classList.add('is-selected');
    }       

    const filterDraw = newHTML.querySelector('.filters-draw .filters-draw__body') as HTMLElement;
    const oldFilterDraw = document.querySelector('.filters-draw .filters-draw__body') as HTMLElement;
 
    oldFilterDraw.parentNode.insertBefore(filterDraw, oldFilterDraw);
    oldFilterDraw.parentNode.removeChild(oldFilterDraw); 

    if (getSavedOpenFilter(false) && (!isMobile() || !isTablet())) {
        const group = document.querySelector(`.filter-group-wrapper .filter-group[data-name="${getSavedOpenFilter(false)}"]`) as HTMLElement;
        const body = document.querySelector(`.filter-group-wrapper .filter-group__visible-body[data-filtername="${getSavedOpenFilter(false)}"]`) as HTMLElement;
        body.style.left = group.offsetLeft.toString() + 'px';
        group.classList.add('active');
        body.classList.add('active');
    }

    const sortBys = document.querySelectorAll<HTMLElement>(`.filter-group-wrapper .filter-group[data-name="SortBy"]`);
    sortBys.forEach(sortBy => { sortBy.classList.remove('active', 'is-selected'); })
}

function scrollFilters() {
    const filters = document.querySelector('.filters-container');
    if (filters) {
        const openFilters = filters.querySelectorAll('.is-visible') as NodeListOf<HTMLElement>;
        openFilters.forEach(filter => {
            filter.scrollTo({
                top: parseInt(filter.getAttribute('data-scroll'))
            });
            filter.removeAttribute('data-scroll');
            let mobileScrollContainer = filter.querySelector('.filter-group__scroll');
            mobileScrollContainer.scrollTo({
                top: parseInt(mobileScrollContainer.getAttribute('data-scroll'))
            });
            mobileScrollContainer.removeAttribute('data-scroll');
        });
    }
}

function preparePageForNewContent() {
    (document.querySelectorAll('.js-pagination') as NodeListOf<HTMLElement>).forEach(e => e.remove());
    (document.querySelectorAll('.product-grid') as NodeListOf<HTMLElement>).forEach(e => e.classList.add('js-pending-delete'));
}

function setupEventListeners() {
    // window.addEventListener('resize', () => debounce(alignElementToBottom('.filter-group__close-all')));
    window.addEventListener('rc-filter-clicked', preparePageForNewContent);
    window.addEventListener('rc-category-clicked', () => {
        let scrollOptions: ScrollToOptions = {
            top: filterOffsetFromTopOfPage()
        };
        scrollTo(scrollOptions, () => window.setTimeout(() => window.scroll(scrollOptions), 5));
        preparePageForNewContent();
    });
}

const setupListingPage = (context = document) => {
    return new Promise((resolve) => {
        setUpWishlistBtnEventListeners(context);
        componentCarousel(context);
        setupFilters({}, context);
        resolve(context);
    });
};

const updateProgressBar = (total: number, page:number) => {   
    const progressBar = document.querySelector('.paging-progress__bar') as HTMLBaseElement;   
    const count = document.querySelectorAll('.associated-product:not(.associated-product--advert)') as NodeListOf<HTMLBaseElement>;
    const calc = (count.length / total) * 100;

    if (typeof progressBar !== 'undefined' && progressBar !== null) {
        progressBar.style.width = `${calc}%`;
    }
}

const filterSelectedCheck = () => {
    const filterSelected = document.querySelector('body').classList.contains('filter-selected');
    if (filterSelected) {
        let scrollOptions: ScrollToOptions = {
            top: filterOffsetFromTopOfPage() - 10
        };
        scrollTo(scrollOptions, () => window.setTimeout(() => window.scroll(scrollOptions), 5));
    }
};

const categoryLinkScroll = (links: HTMLElement) => {
    if (links.clientWidth < links.scrollWidth) links.classList.add('justify-content-start');
    else links.classList.remove('justify-content-start');
};

const quickAddToBag = () => {
    const buttons = document.querySelectorAll('.js-plp-buy') as NodeListOf<HTMLButtonElement>;
    buttons.forEach(btn => {
        btn.removeEventListener('click', quickAddToBagFunction);
        btn.addEventListener('click', quickAddToBagFunction);
    });
};

const quickAddToBagFunction = (e) => {
    e.preventDefault();
    const btn = (e.target as HTMLElement).closest('.btn') as HTMLButtonElement;
    const allBtns = document.querySelectorAll('.js-plp-buy') as NodeListOf<HTMLButtonElement>;
    const parent = btn.closest('.associated-product') as HTMLElement;
    allBtns.forEach(btn => { btn.classList.add('disabled'); });    
    btn.innerText = "Adding";
    const productId = btn.dataset.id as string;
    const stockId = btn.dataset.stock as string;

    // --- get search term if present ---
    const currentUrl = new URL(window.location.href);
    const searchTerm = currentUrl.searchParams.get('q') as string;

    addToBag({
        ...{ productId, stockId: stockId, quantity: 1, searchTerm: searchTerm }
    }).then((data) => {
        if (data.success) {
            btn.innerText = "Added";

            let basketItemCount = parseInt(
                (document.querySelector('.quick-basket__count') as HTMLElement).innerText
            );
            const newCount = basketItemCount += 1;

            updateQuickBasketCount(newCount);
            updateBasketTotal();
            if (!isAny()) previewQuickbasket();

            const gaItem: any = {
                item_id: parent.dataset.pid,
                item_name: parent.dataset.title,
                quantity: 1,
                price: parseFloat(parent.dataset.price),
                item_brand: parent.dataset.brand,
                item_category: parent.dataset.category,
            };

            // only add if this was a search result
            if (searchTerm) {
                gaItem.search_term = searchTerm;
            }

            gaTracking("add_to_cart", false, {
                currency: "GBP",
                value: parseFloat(parent.dataset.price),
                items: [gaItem]
            });
        }

        else alert(data.reason != "" ? data.reason : "Error adding to basket. Please refresh the page and try again.");
        setTimeout(() => {
            allBtns.forEach(btn => { btn.classList.remove('disabled'); });  
            btn.innerText = "Add To Basket";
        }, 3000);
    });
}

const viewListTracking = () => {
    const observer = new IntersectionObserver(sendItemViews);
    const products = document.querySelectorAll('.product-grid .associated-product.associated-product--default');
    products.forEach(element => {
        observer.observe(element);
    });
};

const sendItemViews = (entries) => {
    const intersectingEntries = entries.filter(entry => entry.isIntersecting);

    intersectingEntries.forEach(entry => {
        if (!entry.target) return;
        if (!viewedItems.includes(entry.target)) {
            viewedItems.push(entry.target);
            const elements = Array.from(viewedItems);
            // Extracting data-title and data-id attributes and creating a new array
            const newDataArray = elements.map(element => ({
                "item_name": element.getAttribute("data-title"),
                "item_id": element.getAttribute("data-pid"),
                "price": element.getAttribute("data-price"),
                "item_category": element.getAttribute("data-category"),
                "item_brand": element.getAttribute("data-brand"),
                "index": parseInt(element.getAttribute("data-index")),
            }));
            gaTracking("view_item_list", false, {
                item_list_id: document.querySelector<HTMLInputElement>('input[name="ajaxTitle"]').value,
                item_list_name: document.querySelector<HTMLInputElement>('input[name="ajaxTitle"]').value,
                item_list_type: document.querySelector<HTMLInputElement>('input[name="ajaxType"]').value,
                items: newDataArray
            });
        }
    });
};

const productClickTracking = (element: HTMLElement) => {
    if (!element || !element.classList.contains('associated-product')) return;
    if (element.classList.contains('associated-product--advert')) {
        const promotion_id = `PLP - ${location.href}: ${element.querySelector<HTMLLinkElement>('a').getAttribute('href')}`;
        gaTracking("select_promotion", false, {
            promotion_name: element.dataset.title,
            promotion_id
        });
        gaTracking("view_promotion", false, {
            promotion_name: element.dataset.title,
            promotion_id
        });
    } else {
        const cateogry = document.querySelector<HTMLInputElement>('input[name="ajaxTitle"]').value;
        const price = element.dataset.price;
        const brand = element.dataset.brand;
        const index = element.dataset.index;
        gaTracking("select_item", false, {
            item_list_id: cateogry,
            item_list_name: cateogry,
            items: [
                {
                    item_id: element.dataset.pid,
                    item_name: element.dataset.title,
                    price,
                    item_brand: brand,
                    item_category: cateogry,
                    index
                }
            ]
        });
    }
};

const updatePLPCount = () => {
    const count = document.querySelectorAll<HTMLElement>('.associated-product:not(.associated-product--advert)')?.length;
    if (count > 0) {
        const textSpan = document.querySelector<HTMLElement>('.js-paging-info span');
        if (textSpan) textSpan.textContent = count.toString();
    }
};

const prevPageCheck = () => {
    const url = location.href;
    // Regular expression to match "page=" followed by digits
    var regex = /page=(\d+)/;
    if (regex.test(url)) {
        const pageNumber = parseInt(url.match(regex)[1]);
        if (pageNumber > 1) {
            setTimeout(() => {
                const prevPageBtn = document.querySelector('.js-page-prev') as HTMLLinkElement;
                prevPageBtn?.click();
            }, 100);
        }
    }
};

const exit = () => {
    console.log("Listing: Exit");
};

window.listing = {
    init,
    exit
};